import { PreviewItemNotaFiscal, RegraNotaFiscal, RegraNotaFiscalForm } from '../../../types/notaFiscalApiTypes'
import { Acao, Condicao } from '../../../types/regraApiType'
import { PriorizacaoRegras } from '../../../types/transformacaoApiTypes'
import notaFiscalService from './notaFiscalService'

const buscarCondicoes = async (): Promise<Condicao[]> => notaFiscalService.buscarCondicoes()

const buscarAcoes = async (): Promise<Acao[]> => notaFiscalService.buscarAcoes()

const cadastrarRegra = async (body: RegraNotaFiscalForm, parceiroId?: string | number): Promise<string> => notaFiscalService.cadastrarRegra(body, parceiroId)

const editarRegra = async (body: RegraNotaFiscalForm, parceiroId?: string | number, regraId?: string | number): Promise<string> =>
  notaFiscalService.editarRegra(body, parceiroId, regraId)

const buscarRegras = async (parceiroId?: string | number): Promise<RegraNotaFiscal[]> => notaFiscalService.buscarRegras(parceiroId)

const buscarRegra = async (parceiroId?: string | number, regraId?: string | number): Promise<RegraNotaFiscal> =>
  notaFiscalService.buscarRegra(parceiroId, regraId)

const enviarArquivo = async (body: string[]): Promise<string> => notaFiscalService.enviarArquivo(body)

const previewRegra = async (body: RegraNotaFiscalForm, arquivoId: string): Promise<PreviewItemNotaFiscal> => notaFiscalService.previewRegra(body, arquivoId)

const reordenarPrioridade = async (parceiroId: string | number, body: PriorizacaoRegras[]): Promise<boolean> =>
  notaFiscalService.reordenarPrioridade(parceiroId, body)

export default {
  buscarCondicoes,
  buscarAcoes,
  cadastrarRegra,
  editarRegra,
  enviarArquivo,
  previewRegra,
  reordenarPrioridade,
  buscarRegra,
  buscarRegras
}
